/**
 *
 * NotificationBadge
 *
 */

import React from "react"
import { Badge, Dropdown, Spin, List, Avatar } from "antd"
import { Icon } from "@ant-design/compatible"
// import PropTypes from 'prop-types';
import { truncate } from "lodash"
import "./index.less"
import InfiniteScroll from "react-infinite-scroller"
import { Link } from "react-router-dom"
import { BellFilled } from "@ant-design/icons"
import { loadTexts } from "../../utils/i18n"
import DOMPurify from "dompurify"
// import styled from 'styled-components';

const NotificationBadge = (props) => {
  const intl = loadTexts("header")
  const notifications = (
    <div className="notifications">
      <div className="notifications-header">
        <p>{intl.notifications.title}</p>
        {props.isLoading && (
          <div className="centerSpin">
            <Spin size="small" />
          </div>
        )}{" "}
        <span
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            props.setAllRead()
            e.stopPropagation()
          }}
          className="color-blue">
          {intl.notifications.markAllAsRead}
        </span>
      </div>
      <div className="notifications-scroll">
        <InfiniteScroll
          pageStart={1}
          threshold={10}
          loadMore={(page) => {
            props.fetchNotifications(page)
          }}
          hasMore={props.total > props.notifications.length}
          loader={
            <div className="loader" key={0}>
              cargando...
            </div>
          }
          useWindow={false}>
          <List
            className="notifications-list"
            dataSource={props.notifications}
            renderItem={(item, i) => {
              const sanitizedHTML = DOMPurify.sanitize(item.data.message);
              return (
                <Link
                  to={item.data.link}
                  className={`item ${!item.visited ? "bgGray" : ""}`}
                  onClick={() => {
                    const payload = {
                      id: item.id,
                      link: item.data.link,
                    }

                    props.goToNotification(payload)
                    // window.location.replace(`${window.location.origin}${item.data.link}`);
                  }}>
                  <Avatar
                    src={item.data.image}
                    shape="circle"
                    style={{
                      alignSelf: "center",
                      width: "52px",
                      height: "52px",
                    }}
                  />
                  <div className="item-text">
                    <span className="item-text-first">
                      <strong>{item.data.from}</strong>
                      <span
                        dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
                      />
                    </span>
                    <div className="color-gray-low item-text-last">
                      <span>{item.ago}</span>
                    </div>
                  </div>
                </Link>
              )
            }}
          />
        </InfiniteScroll>
      </div>
    </div>
  )

  return (
    <Dropdown
      trigger={["click"]}
      overlay={notifications}
      placement="bottomCenter"
      className="badge"
      overlayClassName="notification-fixed"
      onVisibleChange={(visible) => {
        if (visible) {
          props.setCount(0)
        }
      }}>
      <Badge className="badge" count={props.count} title="Notifications">
        <BellFilled
          style={{
            color: "white",
            fontSize: "16px",
            lineHeight: "13px",
            padding: "8px 10px",
          }}
        />
      </Badge>
    </Dropdown>
  )
}

NotificationBadge.propTypes = {}

export default NotificationBadge
